import { useRef, useState } from "react";
import { ImagePlus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { errMsg, uploadImage } from "@/lib/api";

export const ImageUpload = ({ onUploaded, label = "Upload photo", testId, maxFiles = 1 }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const files = Array.from(e.target.files || []).slice(0, maxFiles);
    e.target.value = "";
    if (!files.length) return;
    setBusy(true);
    try {
      for (const file of files) {
        onUploaded(await uploadImage(file));
      }
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <input ref={ref} type="file" multiple={maxFiles > 1} accept="image/jpeg,image/png,image/webp,image/gif" className="hidden"
        onChange={pick} data-testid={`${testId}-input`} />
      <button type="button" className="btn-ghost" disabled={busy} onClick={() => ref.current?.click()} data-testid={testId}>
        {busy ? <Loader2 size={13} className="animate-spin" /> : <ImagePlus size={13} />}
        {busy ? "Uploading..." : label}
      </button>
    </>
  );
};
